import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationdatenoteElFindDateParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationdatenoteElFindDateParams, unknown>

const fetchReservationDateNotesByDate = async (params: ApiV2ReservationdatenoteElFindDateParams) => {
  const { data } = await apiClient.v2.apiV2ReservationdatenoteElFindDate(params);
  return checkApiResponse(data);
}

export const v2ReservationDateNoteDateKeys = {
  all: [QUERY_KEY.v2apiV2ReservationdatenoteElFindDate] as const,
  list: (params: ApiV2ReservationdatenoteElFindDateParams) => [...v2ReservationDateNoteDateKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationDateNoteFindDateQueryOptions(params))` */
export const v2ReservationDateNoteFindDateQueryOptions = (params: ApiV2ReservationdatenoteElFindDateParams) => ({
  queryKey: v2ReservationDateNoteDateKeys.list(params),
  queryFn: () => fetchReservationDateNotesByDate(params),
})

export const useV2ReservationDateNoteFindDateQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationDateNoteDateKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationDateNotesByDate(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
